import React, { useState } from "react";
import {
  Form,
  Title,
  Input,
  Button,
  ModalOverlay,
  ModalContent,
  CloseButton,
  InputWrapper,
  ForgotLink,
  ErrorShow,
} from "./style";
import { toast } from "react-toastify";
import logoImg from "../assets/logo/Logo.png";

const ForgotModal = ({ isOpen, onClose }) => {
  const [email, setEmail] = useState("");
  const [errors, setErrors] = useState({});

  const handleForgot = async (e) => {
    e.preventDefault();
    setErrors({});
    if (!email) {
      setErrors((prev) => ({ ...prev, email: "Email is required" }));
      return;
    }

    try {
      const response = await fetch(
        `${process.env.REACT_APP_URL}/forgot-password`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ email }),
        }
      );

      const data = await response.json();

      if (response.ok) {
        toast.success("Password reset link sent to your email");
        onClose();
      } else {
        setErrors((prev) => ({
          ...prev,
          email: data.message || "An error occurred",
        }));
      }
    } catch (error) {
      setErrors((prev) => ({
        ...prev,
        email: "Network error. Please try again later.",
      }));
    }
  };

  if (!isOpen) return null;

  return (
    <>
      <ModalOverlay />
      <ModalContent>
        <CloseButton onClick={onClose}>&times;</CloseButton>
        <Form onSubmit={handleForgot}>
          <Title>
            <img width={200} src={logoImg} alt="logo" />
          </Title>
          <InputWrapper>
            <Input
              type="email"
              placeholder="Email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
            {errors.email && <ErrorShow>{errors.email}</ErrorShow>}
          </InputWrapper>
          <br />
          <Button type="submit">Forgot Password</Button>
        </Form>
        <ForgotLink onClick={onClose}>Back to Login</ForgotLink>
      </ModalContent>
    </>
  );
};

export default ForgotModal;
